import React from 'react';
import Button from '../../../components/Button';
import { Project } from '../../../services/projects';
import { CompetitionAnalysis, SimpleCompetitor } from '../../../types/competitors';

interface ReportsTabProps {
  project: Project;
  competitionAnalysis: CompetitionAnalysis | null;
  isLoading: boolean;
  handleRunAnalysis: () => Promise<void>;
}

const ReportsTab: React.FC<ReportsTabProps> = ({
  project,
  competitionAnalysis,
  isLoading,
  handleRunAnalysis
}) => {
  return (
    <div>
      <h3 style={{ fontSize: '1.4rem', marginBottom: '1.5rem', color: '#1e1e1e' }}>Project Reports</h3>
      
      {isLoading ? (
        <div style={{ textAlign: 'center', padding: '2rem', color: '#666' }}>
          <p>Loading reports...</p>
        </div>
      ) : competitionAnalysis ? (
        <div>
          <div style={{ marginBottom: '2rem' }}>
            <h4 style={{ fontSize: '1.1rem', marginBottom: '1rem', color: '#1e1e1e' }}>Competition Analysis</h4>
            <div style={{ overflowX: 'auto' }}>
              <table style={{ 
                width: '100%', 
                borderCollapse: 'collapse',
                backgroundColor: '#fff',
                borderRadius: '8px',
                overflow: 'hidden',
                boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
              }}>
                <thead>
                  <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #dee2e6' }}>
                    <th style={{ padding: '1rem', textAlign: 'left', fontWeight: 600 }}>Competitor</th>
                    <th style={{ padding: '1rem', textAlign: 'left', fontWeight: 600 }}>Distance</th>
                    <th style={{ padding: '1rem', textAlign: 'left', fontWeight: 600 }}>Rating</th>
                    <th style={{ padding: '1rem', textAlign: 'left', fontWeight: 600 }}>Type</th>
                  </tr>
                </thead>
                <tbody>
                  {competitionAnalysis.competitors.map((competitor: SimpleCompetitor, index: number) => (
                    <tr key={competitor.id || index} style={{ borderBottom: '1px solid #dee2e6' }}>
                      <td style={{ padding: '1rem' }}>{competitor.name}</td>
                      <td style={{ padding: '1rem' }}>{competitor.distance.toFixed(2)} miles</td>
                      <td style={{ padding: '1rem' }}>{competitor.rating.toFixed(1)}</td>
                      <td style={{ padding: '1rem' }}>{competitor.type}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          
          {/* Additional reports would go here */}
          <div style={{ marginBottom: '2rem' }}>
            <h4 style={{ fontSize: '1.1rem', marginBottom: '1rem', color: '#1e1e1e' }}>Market Analysis</h4>
            <div style={{ 
              padding: '2rem', 
              backgroundColor: '#f9f9f9', 
              borderRadius: '4px',
              textAlign: 'center',
              color: '#666'
            }}>
              <p>Market analysis report will be available soon.</p>
            </div>
          </div>
          
          <div>
            <h4 style={{ fontSize: '1.1rem', marginBottom: '1rem', color: '#1e1e1e' }}>Demographic Report</h4>
            <div style={{ 
              padding: '2rem', 
              backgroundColor: '#f9f9f9', 
              borderRadius: '4px',
              textAlign: 'center',
              color: '#666'
            }}>
              <p>Demographic report will be available soon.</p>
            </div>
          </div>
        </div>
      ) : (
        <div style={{ textAlign: 'center', padding: '2rem', color: '#666' }}>
          <p>No reports available yet. Run an analysis to generate reports.</p>
          <div style={{ marginTop: '1rem' }}>
            <Button onClick={handleRunAnalysis}>
              Run Analysis
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReportsTab;
